var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{key:_vm.tick,staticClass:"d-inline",attrs:{"id":_vm.getActiveAppointment}},[_vm._v(_vm._s(_vm.getTimer))])}
var staticRenderFns = []

export { render, staticRenderFns }